export const COLORS = {
  BLUE: {
    75: "#EFF6FF",
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#3B82F6",
    600: "#2563EB",
    700: "#1D4ED8",
    800: "#1E40AF",
    900: "#1E3A8A",
  },
  GREEN: {
    100: "#DCF7D9",
    200: "#B8EFB3",
    300: "#95E78D",
    400: "#71DF68",
    500: "#4ED742",
    600: "#3EAC35",
    700: "#2F8127",
    800: "#1F561A",
    900: "#102B0D",
  },
  ORANGE: {
    100: "#FFEED1",
    200: "#FFD1A3",
    300: "#FFBA75",
    400: "#FFA347",
    500: "#FF8C19",
    600: "#CC7014",
    700: "#99540F",
    800: "#66380A",
    900: "#331C05",
  },
  RED: {
    100: "#F9D7D7",
    200: "#F4AFAF",
    300: "#EE8787",
    400: "#E85E5E",
    500: "#E23636",
    600: "#B52B2B",
    700: "#882121",
    800: "#5B1616",
    900: "#2D0B0B",
  },
  GREY: {
    50: "#F2F3F5",
    100: "#E6E8EA",
    200: "#CCD1D6",
    300: "#B3BAC1",
    400: "#9AA3AD",
    500: "#818C98",
    600: "#67707A",
    700: "#4D545B",
    800: "#252525",
    900: "#141414",
    950: "#0a0a0a",
  },
  WHITE: "#ffffff",
  BLACK: "#000000",
};
